import { LeftSectionStatsTranslations } from "./types";

export const deTranslations: LeftSectionStatsTranslations = {
    patients: "Patient:innen",
    students: "Studierende",
    sessions: "Session",
    averageScore: "Durchschnittsscore"
};